import React, { useEffect, useState } from "react";
import { getAgentsByAgentMerchant } from "../actions/agent";
import { Box, CircularProgress, FormControl, MenuItem, Select, Typography } from "@mui/material";

const ComboAgentsByMerchant = ({ token, agent, setAgent }) => {
	const [agents, setAgents] = useState(null);

	useEffect(() => {
		getAgentsByAgentMerchant(token, (data) => {
			if (!data.error) {
				setAgents(data.data);
			}
		});
	}, []);

	const handleChange = (e) => {
		setAgent(e.target.value);
	};

	return (
		<>
			{agents ? (
				<FormControl sx={{ width: "100%", alignItems: "center", display: "flex" }} fullWidth>
					<Box sx={{ width: "100%", textAlign: "left", marginTop: 2, marginBottom: 1 }}>
						<Typography component="h2" variant="subtitle2" gutterBottom>
							Select Agent
						</Typography>
					</Box>
					<Select size="medium" value={agent ?? ""} onChange={handleChange} sx={{ borderRadius: 6, display: "flex" }} fullWidth>
						<MenuItem value={"first"} key={-1} component="div" style={{ display: "flex" }} disabled>
							<Box sx={{ display: "flex" }}>
								<Typography sx={{ fontSize: "18px", color: "#CCCCCC" }} component="div">
									{"Select Agent"}
								</Typography>
							</Box>
						</MenuItem>
						{agents.map((agent) => {
							return (
								<MenuItem value={agent._id} selected key={agent._id} component="div" style={{ display: "flex" }}>
									<Box sx={{ display: "flex" }}>
										<Typography sx={{ fontSize: "18px", marginLeft: 2 }} component="div">
											{agent.username}
										</Typography>
									</Box>
								</MenuItem>
							);
						})}
					</Select>
				</FormControl>
			) : (
				<CircularProgress color="primary" size={25} thickness={5} />
			)}
		</>
	);
};

export default ComboAgentsByMerchant;
